module.exports = __webpack_public_path__ + "img/logo.d2e0860e.png";